import cx from 'classnames'
import {ReactComponent as DiamondIcon} from 'icons/proof/diamond.svg'
import {ReactComponent as FireIcon} from 'icons/proof/fire.svg'
import {ReactComponent as HourglassIcon} from 'icons/proof/hourglass.svg'
import {ReactComponent as ThumbsUpIcon} from 'icons/proof/thumbs-up.svg'
import {ReactComponent as ZapIcon} from 'icons/proof/zap.svg'

type SocialProofBadgeType = 'none' | 'urgent' | 'limited' | 'popular' | 'trusted' | 'rated'

type SocialProofBadgeParam = {
  text: string
  icon?: React.FunctionComponent
}

type SocialProofBadgeParams = Record<SocialProofBadgeType, SocialProofBadgeParam>

const badgeParams: SocialProofBadgeParams = {
  none: {text: ''},
  urgent: {text: 'Selling Fast!', icon: FireIcon},
  limited: {text: 'Only a few items left', icon: HourglassIcon},
  popular: {text: 'Booked 5 times today', icon: ZapIcon},
  trusted: {text: 'Trusted by 90% of travelers', icon: DiamondIcon},
  rated: {text: '4.9 average rating', icon: ThumbsUpIcon},
}

interface SocialProofBadgeProps {
  type?: SocialProofBadgeType
  className?: string
}

function Icon({icon: IconComponent}: {icon: React.FunctionComponent | undefined}) {
  if (!IconComponent) {
    return null
  }

  return <IconComponent />
}

export default function SocialProofBadge({type = 'none', className = ''}: SocialProofBadgeProps) {
  const {text, icon} = badgeParams[type]

  return (
    <div
      className={cx(
        'social-proof-badge',
        'flex',
        'gap-x-1',
        'items-center',
        'text-sm',
        'text-[#FF9400]',
        'font-medium',
        className
      )}
    >
      <Icon icon={icon} />
      <span>{text}</span>
    </div>
  )
}
